import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { collectEventfireGa4, getGa4PageViewSet } from 'utils/common';
import s from './PrimeSubscriberStrip.scss';

function PrimeSubscriberStrip({ isHomePage, isArticleshow, isLiveBlog }) {
  const [showStrip, setShowStrip] = useState(false);
  let key = '';
  if (isHomePage) {
    key = 'home';
  } else if (isArticleshow) {
    key = 'article';
  } else if (isLiveBlog) {
    key = 'liveblog';
  }
  useEffect(() => {
    const doNotShow =
      localStorage.getItem(`showSubscriberStrip_${key}`) === 'false';
    if (doNotShow) {
      setShowStrip(false);
    } else {
      setShowStrip(true);
      localStorage.removeItem(`showSubscriberStrip_${key}`);
    }
  }, []);

  const fireGA4 = obj => {
    const gaPageViewObj = getGa4PageViewSet() || {};
    const collatedGadata = {
      ...gaPageViewObj,
      event: obj?.action === 'click' ? 'select_item' : 'view_item_list',
    };
    return collectEventfireGa4(collatedGadata, {
      item_name:
        window.location.href.indexOf('.cms') > -1
          ? document.title
          : window.location.href,
      item_id: '',
      item_brand: 'product_interventions',
      item_category: 'Nudges',
      item_category2: obj?.item_category2 || 'N/A',
      item_category3: obj?.item_category3 ? obj?.item_category3 : 'N/A',
      item_category4: obj?.item_category4 ? obj?.item_category4 : 'N/A',
    });
  };

  const closeBtnHandler = () => {
    localStorage.setItem(`showSubscriberStrip_${key}`, false);
    setShowStrip(false);
    fireGA4({
      action: 'click',
      item_category3: 'announcement_strip_close',
      item_category2: 'homepage',
    });
  };

  return (
    <div className={`${s.subscribe_strip} ${showStrip ? s.showStrip : ''}`}>
      <div className={s.inner_content}>
        <span className={s.toiplus_logo} />
        Welcome to the{' '}
        <span className={s.text_strong}>
          {' '}
          TOI+ premium reading experience,
        </span>{' '}
        exclusively for subscribers.
      </div>
      <span className={s.close} onClick={() => closeBtnHandler()} />
    </div>
  );
}

PrimeSubscriberStrip.propTypes = {
  isHomePage: PropTypes.bool,
  isArticleshow: PropTypes.bool,
  isLiveBlog: PropTypes.bool,
};

PrimeSubscriberStrip.defaultProps = {
  isHomePage: false,
  isArticleshow: false,
  isLiveBlog: false,
};

export default PrimeSubscriberStrip;
